import { Drawer } from "@verde/compose-ui";
import { ExternalLinkIcon } from "@verde/icons";
import React from "react";
import { useNavigate } from "react-router-dom";
import PanelSearchClientHistoryListing from "./panel-search-client-history-listing";

export interface PanelSearchClientHistoryDrawerProps {
  onClose: () => void;
}

function PanelSearchClientHistoryDrawer({
  onClose,
}: PanelSearchClientHistoryDrawerProps) {
  const navigate = useNavigate();

  return (
    <Drawer
      open
      onClose={onClose}
      header={{
        title: "Histórico de consultas",
        description:
          "Acompanhe todas as consultas que você já fez usando o Raio-X rural.",
      }}
      footer={{
        primary: {
          children: "Ver todos",
          icon: <ExternalLinkIcon />,
          onClick: () => {
            navigate("/clientes");
          },
        },
        secondary: {
          children: "Fechar",
          onClick: onClose,
        },
      }}
    >
      <PanelSearchClientHistoryListing />
    </Drawer>
  );
}

export default React.memo(PanelSearchClientHistoryDrawer);
